/**
 * Build FormData for creating/updating a banner slide (multipart, includes image file)
 */
export const bannerSlideFormUploader = (data) => {
    const formdata = new FormData()

    formdata.append('title', data.title)
    formdata.append('description', data.description || '')
    formdata.append('link', data.link || '')
    formdata.append('status', data.status || 'active')

    if (data.image) {
        formdata.append('image', data.image)
    }

    return formdata
}